import styled from 'styled-components';

export const WrapperBack = styled.div<{ isToggle: boolean }>`
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: ${p => (p.isToggle ? 'flex-start' : 'center')};

  padding-left: ${p => (p.isToggle ? '12px' : '0px')};
  border-radius: 6px;
  cursor: pointer;
  .text {
    color: ${props => props.theme.colors.text.primary};
    overflow: hidden;
    white-space: nowrap;
  }
  &:hover {
    background: #fafafa;
  }
`;

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f1f1f1;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 12px;
    height: 12px;
  }
`;
